module.exports = __webpack_public_path__ + "img/missao.e4621cfb.jpg";